
'use strict';
require( 'slick-carousel' );

jQuery( function() {

  var initSlick = function() {

    var width = jQuery( window ).width();

    var mobile = 768;

    jQuery( '.title_content_img_wrap.slick-slider' ).slick( 'unslick' );

    if ( width < mobile ) {

      jQuery( '.title_content_img_wrap' ).slick({
        slidesToShow: 1,

        slidesToScroll: 1,

        autoplay: true,

        autoplaySpeed: 4000,

        dots: true,

        infinite: true,

        cssEase: 'linear',

        prevArrow: false,

        nextArrow: false
      });

    }
  };

  jQuery( window ).resize( initSlick );
  initSlick();

});
